import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=0787b86a&scoped=true"
import script from "./grid-item.vue?vue&type=script&lang=js"
export * from "./grid-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787b86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0787b86a')) {
      api.createRecord('0787b86a', component.options)
    } else {
      api.reload('0787b86a', component.options)
    }
    module.hot.accept("./grid-item.vue?vue&type=template&id=0787b86a&scoped=true", function () {
      api.rerender('0787b86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/grid-item.vue"
export default component.exports